import { Component, Input } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { FabricComposition } from '../../../../models/greige/greige';

@Component({
  selector: 'app-greige-detail-modal',
  templateUrl: './greige-detail-modal.component.html',
  styleUrl: './greige-detail-modal.component.scss',
})
export class GreigeDetailModalComponent extends BaseModalComponent<null> {
  @Input() greige: FabricComposition[] = [];

  onClose() {
    this.close({ action: 'close', data: null });
  }

  onSave() {}
}
